import UserDataService from 'common/services/userData.service.js';

class LoansUserDataService extends UserDataService {
  constructor() {
    super();
    this.senior = false;
  }

  getModalities() {
    return this._employee.modalities;
  }

  setSenior(senior) {
    this.senior = senior;
  }

  getSenior() {
    return this.senior;
  }

  clean() {
    super.clean();
    this.senior = false;
  }
}

export default LoansUserDataService;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loansUserData.service.js